<app-download-button
  [(process)]="processing"
  (processChange)="download($event)"
></app-download-button>
